<template>
  <el-dialog
      :visible.sync="visible"
      width="800px"
      :before-close="handleClose">

    <div class="bg">
      <el-row style="width: 63%;">
        <el-col :span="8" class="form">
          <div>持有人</div>
        </el-col>
        <el-col :span="16" class="form">
          <div style="text-align: left">{{ $store.state.account.user.certInfo.holder }}</div>
        </el-col>
        <el-col :span="8" class="form">
          <div>颁发者</div>
        </el-col>
        <el-col :span="16" class="form">
          <div style="text-align: left">{{ $store.state.account.user.certInfo.issuer }}</div>
        </el-col>
        <el-col :span="8" class="form">
          <div>证件号</div>
        </el-col>
        <el-col :span="16" class="form">
          <div style="text-align: left">{{ $store.state.account.user.certInfo.cerditCode }}</div>
        </el-col>
        <el-col :span="8" class="form">
          <div>序列号</div>
        </el-col>
        <el-col :span="16" class="form">
          <div style="text-align: left">{{ $store.state.account.user.certInfo.certSn }}</div>
        </el-col>
        <el-col :span="8" class="form">
          <div>有效期</div>
        </el-col>
        <el-col :span="16" class="form">
          <div style="text-align: left">{{ $store.state.account.user.certInfo.validity }}</div>
        </el-col>
      </el-row>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "digitalCertificate",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {}
  },
  mounted() {
    console.log(this.$store.state.account.user.certInfo)
  },
  methods: {
    handleClose() {
      this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-dialog__footer {
  text-align: center !important;
}

.bg {
  background: url("~@/assets/ca-bg.png") no-repeat center center;
  height: 414px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form {
  line-height: 20px;
  margin-bottom: 24px;
}
</style>
